import React, {
	useState,
//	useEffect,
} from 'react';

import Loading from 'components/loading.js';

import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

//import { Control } from 'react-bootstrap/Control';
/**
curl --location --request POST 'https://api.optiweigh.io/user-auth-dev/login' \
--header 'X-OPW-source-ref: postman-matt' \
--header 'Content-Type: application/json' \
--header 'Cookie: refresh_token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJvcHdjaWQiOjIwLCJpYXQiOjE1OTQzMTE3NjJ9.lCi__03jsxkGewcst5XlHAH2V4YliUn52a2nBJz2lcY; __cfduid=da1177ba5e2a4a62f8fc54091edd04d361592089641' \
--data-raw '{
    "username": "info@optiweigh.com.au",
    "password": "bar"
}'
*/

// https://medium.com/@ryanchenkie_40935/react-authentication-how-to-store-jwt-in-a-cookie-346519310e81
//class Login extends Component {
export const LoginModal = (props) => {
	//const [username, setUsername] = useState( '' );
	//const [password, setPassword] = useState( '' );
	const [values, setValues] = useState({username:'', password:''});
	const [loading, setLoading] = useState(false);
	//const dispatch = useDispatch()

	const handleChange = (evt) => {
		evt.persist();
		setValues(values => ({ ...values, [evt.target.name]: evt.target.value }));
	};

	const handleSubmit = (evt) => {
		evt.persist();
		evt.preventDefault()
		console.log('actionUserLogin')
		console.log(evt.target)
		setLoading(true)
		//dispatch(actionUserLogin(values, setLoading))
		setValues({username:'', password:''})
	}
	// const handleTest = (evt) => {
	// 	evt.persist();
	// 	evt.preventDefault()
	// 	//console.log('actionUserLogin')
	// 	//console.log(evt.target)
	// 	dispatch(actionRefreshToken(values))
	// 	//setValues({username:'', password:''})
	// }
	//console.log('values', values)
	return (
		<Modal
			{...props}
			size="lg"
			aria-labelledby="contained-modal-title-vcenter"
			centered
		>
		<Modal.Header closeButton>
			<Modal.Title id="contained-modal-title-vcenter">
				User Login
			</Modal.Title>
		</Modal.Header>
		<Modal.Body>
			<Form onSubmit={ handleSubmit }>
				{/* <Messages /> */}
				{/* <h1>Login</h1> */}
				<Row>
					<Col sm='4'><p style={{paddingTop: '0.3em'}}>Username</p></Col>
					<Col sm='8'>
						<Form.Control
							id = 'username'
							name = 'username'
							//placeholder="Enter username..."
							//placeholder="info@optiweigh.com.au"
							//value = {"info@optiweigh.com.au"}//debug
							value = { values.username }
							onChange = { handleChange }
							//style = { controlStyle }
							//value = { value }
							//pattern = {'^(\d*\.)?\d+$'}	// numeric
							//pattern = {'^[0-9]+$'}	// integer
							//onInvalid = { handleInvalid }
							//pattern="\d{1,2}/\d{1,2}/\d{4}"
							//required = { required }
							//isInvalid = {(props.value == '')}
							//isInvalid = { true }
						/>
					</Col>
				</Row>
				<Row>
					<Col sm = { 4 }>
						<p style={{paddingTop: '0.3em'}}>Password</p></Col>
					<Col sm = { 8 }>
					<Form.Control
						type='password'
						name='password'
						//placeholder='Password'
						//placeholder='bar'
						//value={'bar'}//debug
						value={ values.password }
						onChange={ handleChange }
					/>
					</Col>
				</Row>
			</Form>
		</Modal.Body>
		<Modal.Footer>
			{/* <input type='submit'/> */}
			<Loading loading = { loading } />&nbsp;
			<Button
				type='submit'
				onClick = { handleSubmit }
				variant="info"
				disabled = { (values.username.length < 2 || values.password.length < 2) }
				title = {((values.username.length < 2 || values.password.length < 2))?'Enter username and password':'Click to login'}
			>
			Login</Button>&nbsp;
			<Button onClick={props.onHide}>Close</Button>

			{/* <Button
				//type='submit'
				onClick = { handleTest }
				variant="info"
				//disabled = { (values.username.length < 2 || values.password.length < 2) }
				//title = {((values.username.length < 2 || values.password.length < 2))?'Enter username and password':'Click to login'}
			>
			Refresh</Button>&nbsp; */}
		</Modal.Footer>
	  </Modal>
	)
}